"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyLoadingTypes = exports.sharedI18nKey = void 0;

var sharedI18nKey = function sharedI18nKey(suffix) {
  return "RichTextLib.shared." + suffix;
};

exports.sharedI18nKey = sharedI18nKey;
var LazyLoadingTypes = {
  default: null,
  lazy: 'lazy'
};
exports.LazyLoadingTypes = LazyLoadingTypes;